"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtEdit = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtEdit = function SvgBtEdit(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.99241 7.50029L7.99236 7.50029C6.86491 7.50157 5.95128 8.41521 5.95 9.54265V9.54271L5.95 19.9269L5.95 19.927C5.95128 21.0544 6.86491 21.9681 7.99236 21.9693H7.99241H19.1734H19.1735C20.3009 21.9681 21.2146 21.0544 21.2159 19.927V19.9269V16.3887C21.2159 16.141 21.0151 15.9402 20.7674 15.9402C20.5197 15.9402 20.3189 16.141 20.3189 16.3887V19.9267C20.3181 20.5591 19.8058 21.0716 19.1734 21.0722H7.99246C7.36006 21.0716 6.84771 20.5591 6.84697 19.9267V9.54277C6.84771 8.9105 7.36006 8.398 7.99247 8.39726H11.5305C11.7782 8.39726 11.979 8.19649 11.979 7.94878C11.979 7.70123 11.7782 7.50029 11.5305 7.50029L7.99241 7.50029Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.2776 17.1716C10.2343 17.3273 10.2783 17.4941 10.3925 17.6085L10.3925 17.6085C10.5069 17.7227 10.6737 17.7667 10.8294 17.7236L10.8294 17.7236L14.2046 16.7886C14.2792 16.7679 14.3472 16.7283 14.402 16.6735L21.511 9.56415L21.5111 9.56411C22.2297 8.84382 22.2297 7.67779 21.5111 6.95751L21.511 6.95747L21.0434 6.48987C20.3236 5.77004 19.1566 5.77004 18.4367 6.48987L11.3275 13.5991C11.2727 13.6539 11.2331 13.7219 11.2125 13.7965L10.2776 17.1716ZM10.2776 17.1716L10.3258 17.185L10.2776 17.1716L10.2776 17.1716ZM20.4896 9.31721L18.6837 7.51132L19.0711 7.12407L19.0711 7.12406C19.4405 6.7546 20.0396 6.7546 20.4091 7.12406L20.4091 7.12407L20.8768 7.59161C20.8768 7.59162 20.8768 7.59164 20.8768 7.59165C21.2457 7.96158 21.2457 8.56019 20.8768 8.92996L20.4896 9.31721ZM20.4896 9.31721L20.8768 8.93L20.4896 9.31721ZM14.1075 15.6992L12.3019 13.8934L18.0495 8.14566L19.8552 9.9514L14.1075 15.6992ZM11.3536 16.6476L11.8816 14.7416L13.2595 16.1196L11.3536 16.6476Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  }));
};

exports.SvgBtEdit = SvgBtEdit;